import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
// layouts
import CompactLayout from 'src/layouts/compact';

// ----------------------------------------------------------------------

const Page404 = lazy(() => import('src/pages/404'));
const OffertaPage = lazy(() => import('src/pages/partners/offerta'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  {
    element: (
      <CompactLayout>
        <Outlet />
      </CompactLayout>
    ),
    children: [
      { path: '404', element: <Page404 /> },
    ],
  },
  {
    path: 'partners',
    children: [
      { path: 'offerta', element: <OffertaPage /> },
    ],
  },
];
